import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Loading from "../../components/Loading";
import Paper from '@mui/material/Paper';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Accordion, AccordionDetails, AccordionSummary, Badge, CardActions, CardHeader, useTheme } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import api from '../../services/api';
import LoadingButton from '@mui/lab/LoadingButton';

import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import icon from '../../image/coletaExtraIconGreen.svg'

import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import AutoDeleteIcon from '@mui/icons-material/AutoDelete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DeleteIcon from '@mui/icons-material/Delete';
import SolicitarColetaExtra from './components/SolicitarColetaExtra';
import HeaderBody from '../../components/HeaderBody';

function ColetaExtra({setShowColetaExtra, user}) {
    const theme = useTheme();
    let initialized = false
    let idContrato = user.idContrato;
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const getStart = async (contrato) => {
        setLoading(true)
        setPage(1);
        api.get(`/clients/coleta/extra/0`,{
            params: {
                page: 0,
                idcontrato: contrato,
                limit: 10,
            }
        }).then(function (response) {
            let {data, status} = response.data;
            if(status === true){
                if(data != null){
                    setList(data)
                }else{
                    setList([])
                }
            }
            setLoading(false)
            // eslint-disable-next-line react-hooks/exhaustive-deps
            initialized = false;
        }).catch(function(error){
            console.log(error)
            setLoading(false)
            initialized = false;
        });
    }
    useEffect(() => {
        if(idContrato !== 0 && idContrato != null && idContrato !== undefined){
            if (!initialized) {
                // eslint-disable-next-line react-hooks/exhaustive-deps
                initialized = true;
                getStart(idContrato);
            }
        }
    }, [idContrato]);
    const [ page, setPage ] = useState(1);
    const [loadingBt, setLoadingBt] = useState(false);
    const loadMore = async (contrato) => {
        setLoadingBt(true)
        api.get(`/clients/coleta/extra/0`,{
            params: {
                page,
                idcontrato: contrato,
                limit: 10,
            }
        }).then(function (response) {
            let {data, status} = response.data;
            if(status === true){
                if(data != null){
                    setList(oldList => [...oldList, ...data]);
                }
            }
            setLoadingBt(false)
            setPage(page + 1);
        }).catch(function(error){
            console.log(error)
            setLoadingBt(false)
        });
    }
    
    const [height, setWidth] = useState(0);
    useEffect(() => {
        const element = document.getElementById('home');
        if (element) {
          setWidth(element.getBoundingClientRect().height - 260); // or height
        }
    }, []);

    function check(etapa) {
        if(etapa.tipo_id === 9){
            return etapa;
        }
    }
    const Motivo = ({etapas}) => {
        const result = etapas.filter(check);
        return (
            <Typography variant="body2">Motivo da reprovação: {result[0].comentario}</Typography>
        );
    }
    const renderFaturas = (element, idx) => {
        let {data, osId, endereco, nome, residuo, idStatus, notifica, etapas, quantidade} = element;
        return (
            <div key={idx} className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" style={{marginBottom: 20, marginTop: 20}}>
                <Paper elevation={12}>
                    <Card className={theme.palette.mode === "dark" ? "bg-dark text-white" : null}>
                        <CardHeader
                            avatar={
                            idStatus === 1 ? (
                                <Avatar sx={{ backgroundColor: 'var(--main-bg-color)', width: 50, height: 50 }} >
                                    <DeleteIcon color={"var(--main-white-color)"} size={30} />
                                </Avatar>
                            ) : (
                                idStatus === 9 ? (
                                <Avatar sx={{ backgroundColor: '#FF0000', width: 50, height: 50 }} >
                                    <DeleteForeverIcon color={"var(--main-white-color)"} size={30} />
                                </Avatar>
                                ) : (
                                <Avatar sx={{ backgroundColor: '#a3a3a3', width: 50, height: 50 }} >
                                    <AutoDeleteIcon color={"var(--main-white-color)"} size={30} />
                                </Avatar>
                                )
                            )
                            }
                            title={data}
                            subheader={nome}
                            action={
                                notifica && (<Badge variant="dot" color="error" style={{marginRight: 10}} />)
                            }
                        />
                        <CardContent style={{marginTop: -20}}>
                            <Typography variant="body2" style={{marginTop: 10}}>
                                Endereço: {endereco}<br />
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                Resíduo: {residuo} <br />
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                Quantidade: {quantidade} unidades
                            </Typography>
                            {idStatus === 9 && (
                                <Motivo etapas={etapas} />
                            )}
                            {idStatus === 1 && (
                                <Typography variant="body2" >Ordem gerada: {osId}</Typography>
                            )}
                        </CardContent>
                        {etapas && (
                            etapas.length === 1 ? (
                                <ListItem>
                                    <ListItemIcon>
                                        <AccessTimeIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={etapas[0].tipo}
                                        secondary={etapas[0].data + " - " + etapas[0].hora}
                                    />
                                </ListItem>
                            ) : (
                                <Accordion>
                                    <AccordionSummary
                                    style={{margin: 0}}
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                    >
                                        <ListItem>
                                            <ListItemIcon>
                                                {etapas[0].tipo_id === 1 && (
                                                    <NotificationImportantIcon />
                                                )}
                                                {etapas[0].tipo_id === 2 && (
                                                    <AccessTimeIcon />
                                                )}
                                                {etapas[0].tipo_id === 3 && (
                                                    <CheckCircleOutlineIcon />
                                                )}
                                                {etapas[0].tipo_id === 4 && (
                                                    <AccessTimeIcon />
                                                )}
                                                {etapas[0].tipo_id === 9 && (
                                                    <DoDisturbIcon />
                                                )}
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={etapas[0].tipo}
                                                secondary={etapas[0].data + " - " + etapas[0].hora}
                                            />
                                        </ListItem>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {etapas && (
                                            etapas.length > 1 && (
                                                etapas.map((etapa, index) => (
                                                    index !== 0 && ( 
                                                        <ListItem key={etapa.id}>
                                                            <ListItemIcon>
                                                                {etapa.tipo_id === 1 && (
                                                                    <NotificationImportantIcon />
                                                                )}
                                                                {etapa.tipo_id === 2 && (
                                                                    <AccessTimeIcon />
                                                                )}
                                                                {etapa.tipo_id === 3 && (
                                                                    <CheckCircleOutlineIcon />
                                                                )}
                                                                {etapa.tipo_id === 4 && (
                                                                    <AccessTimeIcon />
                                                                )}
                                                                {etapa.tipo_id === 9 && (
                                                                    <DoDisturbIcon />
                                                                )}
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                primary={etapa.tipo}
                                                                secondary={etapa.data + " - " + etapa.hora}
                                                            />
                                                        </ListItem>
                                                       
                                                    )
                                                ))
                                            )
                                        )}
                                    </AccordionDetails>
                              </Accordion>
                            )
                        )}
                    </Card>
                </Paper>
            </div>
        );
    }
    return (
        <Card style={{margin: 20}} className={theme.palette.mode === "dark" ? "bg-dark text-white" : null}>
            <Loading open={loading} />
            <Card.Header>
                <HeaderBody title={"Solicitações de coleta extra"} icon={icon} setShow={setShowColetaExtra} />
            </Card.Header>
            <Card.Body className='row' style={{paddingTop: 0, paddingBottom: 0}}>
                <div style={{overflow: "auto", height: height}}>
                    {list.map((elemeto, index) => (
                        renderFaturas(elemeto, index)
                    ))}
                    {list.length > 0 && (
                        <div className="col-sm-12 col-xs-12 col-12 col-md-12 col-lg-12 col-xl-12" >
                            <CardActions style={{justifyContent: 'space-around'}}>
                                <LoadingButton 
                                variant="secondary" 
                                loading={loadingBt} 
                                onClick={() => loadMore(idContrato)}
                                >
                                    Mostrar mais...
                                </LoadingButton>
                            </CardActions>
                        </div>
                    )}
                    {user.status === "Contrato Ativo" ? <SolicitarColetaExtra user={user} getStart={getStart} setLoading={setLoading} /> : null}
                </div>
            </Card.Body>
        </Card>
    );
}

export default ColetaExtra;